<template>
  <el-container>
    <el-main>
      <el-row type="flex" justify="space-start" :gutter="30">
        <el-col :span="18">
          <el-card class="box-card">
            <div class="card-header">
            
                <div
              slot="header"
              class="clearfix"
            >
              <h2 class="card-title">
                <router-link :to="'/mailchimp/edit/'+member.id">{{member.merge_fields.FNAME}} {{member.merge_fields.LNAME}}</router-link>
                <small class="pull-right">Customer ID: {{member.id}}</small>
              </h2>
                <i class="ti-email"></i>
              {{member.email_address}}
              </div>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </el-main>
  </el-container>
</template>
<script>
import api from "./api";
export default {
  data() {
    return {
      member: {}
    };
  },
  methods: {
    getMember(id) {
      api
        .getMember(id)
        .then(response => {
          console.log(response);
          this.member = response.data;
       
          console.log(this.member);
        });
    }
  },

  async mounted() {
    this.getMember(this.$route.params.id);
  }
};
</script>


// WEBPACK FOOTER //
// src/components/Mailchimp/Detail.vue